import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { SprayProductOrderIndex } from 'services/sprayEvents/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductOrder } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productOrder: SprayProductOrderIndex;
}

type Props = OwnProps & ConnectedProps;

export class ProductOrderTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productOrder } = this.props;

        return <TableCell>{productOrder}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productOrder: makeSelectProductOrder()
});

export default connect(mapStateToProps)(ProductOrderTableCellComponent);
